import { createSlice } from '@reduxjs/toolkit';
import { AlgoliaConfigs } from '@alltrails/types/algoliaConfigs';

const initialState: AlgoliaConfigs = {
  applications: {
    primary: {
      applicationId: '',
      apiKey: ''
    },
    secondary: {
      applicationId: '',
      apiKey: ''
    }
  },
  indexes: {
    primaryIndex: {
      id: '',
      application: 'primary'
    },
    pendingIndex: {
      id: '',
      application: 'primary'
    },
    mapsIndex: {
      id: '',
      application: 'primary'
    },
    alertsIndex: {
      id: '',
      application: 'primary'
    },
    usersIndex: {
      id: '',
      application: 'primary'
    }
  }
};

export const algoliaConfigsSlice = createSlice({
  name: 'algoliaConfigs',
  initialState,
  reducers: {}
});

export default algoliaConfigsSlice.reducer;
